<template lang="pug">
transition(name="fade")
  .MessageOverlay(v-if="!isFinished")
    .inner
      .title {{message}}
</template>

<script>
// import moment from 'moment'
// import soundService from '@/services/SoundService'

export default {
  name: 'km-message-overlay',
  components: {},
  props: {
    duration: {
      type: Number,
      default: 1000
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isFinished: false,
      decrementTimerInstance: null
    }
  },
  computed: {},
  methods: {
    end() {
      this.isFinished = true
      clearTimeout(this.decrementTimerInstance)
      this.$emit('onFinished')
    }
  },
  mounted() {
    this.decrementTimerInstance = setTimeout(() => {
      this.end()
    }, this.duration)
  },
  beforeDestroy() {
    clearTimeout(this.decrementTimerInstance)
  }
}
</script>

<style lang="scss" scoped>
.MessageOverlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  align-items: center;
  justify-content: center;
  z-index: 1001;

  .inner {
    display: flex;
    width: 100%;
    padding: 50px;
    color: orange;
    font-size: 10rem;
    align-items: center;
    justify-content: center;
  }

  .title {
  }
}
</style>
